import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

const VERSION = 3
const DATA_KEY_PREFIX = "rp:data"
const EXPIRE_TIME = 60 * 60 * 1000

interface ReportedProblems {
    reported_problems_id: number[]
}

interface DataWithMeta {
    data: ReportedProblems
    expiry: number
}

class ResultsStorage {
    storage: StorageWrapper | undefined
    key: string

    constructor() {
        this.storage = isStorageAvailable ? new StorageWrapper(window.localStorage) : undefined
        this.key = `${DATA_KEY_PREFIX}:${VERSION}`
    }

    store(data: ReportedProblems) {
        this.storage?.storeObject(this.key, {
            data: data,
            expiry: Date.now() + EXPIRE_TIME,
        })

        return this.key
    }

    get() {
        const date = Date.now()
        const data = this.storage?.getObject<DataWithMeta>(this.key)

        if (data && data.expiry < date) {
            const key = this.store({ reported_problems_id: [] })
            return this.storage?.getObject<DataWithMeta>(key)?.data
        }

        return data?.data
    }

    get reportedProblemsId() {
        return this.get()?.reported_problems_id || []
    }

    clean() {
        this.storage?.remove(this.key)
    }
}

export const ReportedProblemsStorage = new ResultsStorage()
